import { httpClient } from '../http/httpClient'

export interface CheckUserResponse {
  status: string
}

export async function checkUser(id: string) {
  const { data } = await httpClient.patch<CheckUserResponse>(`/user/${id}`)

  return data
}
